import React from "react";

const colorFor = (v) => (v >= 80 ? "#10B981" : v >= 60 ? "#F59E0B" : "#EF4444");

export const MatchRing = ({ value = 0, size = 72, stroke = 6, label = true, testId }) => {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const dash = (clamped / 100) * circ;
  const color = colorFor(clamped);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#1F2937" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={`${dash} ${circ}`}
          strokeLinecap="round"
          style={{ transition: "stroke-dasharray 700ms ease" }}
        />
      </svg>
      {label && (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-display text-lg font-semibold" style={{ color }}>
            {clamped}
          </span>
        </div>
      )}
    </div>
  );
};
